import React from 'react'

function AdminExams() {
  return (
    <div>AdminExams</div>
  )
}

export default AdminExams